export default __webpack_public_path__ + "976d36a70448284373efd40d3f5bd8c4.svg";